import fetchAPI from '../../fetchAPI';

export interface RetryJobResponse {
  jobId: string;
  status: 'pending';
}

export const callRetryJob = async (jobId: string): Promise<iResponse<RetryJobResponse>> => {
  const response = await fetchAPI<RetryJobResponse>({
    method: 'POST',
    route: `jobs/${jobId}/retry`,
    data: {}
  });
  return response;
};

export default callRetryJob;
